module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-3"
  }, [_c('h1', [_vm._v(_vm._s(_vm.msg))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.navigateToOffers
    }
  }, [_vm._v("Go To Offers")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9d0f83d8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 272
// module chunks = 5